import projection from '../generated/pw2202f1.json'; import { AcceptanceManifest } from '../types';
export const pw2202f1AcceptanceManifest = projection as AcceptanceManifest;
